// src/components/Header.jsx
import React from 'react';
import UserMenu from './UserMenu';
import Logo from './Logo';
import TabNavigation from './TabNavigation';
import './Header.css';

const Header = ({
  userData,
  onLogout,
  onResetPassword,
  logoUrl,
  currentTab,
  onTabChange,
  userRole,
  isTransitioning,
}) => (
  <header className="app-header">
    <UserMenu
      userData={userData}
      onLogout={onLogout}
      onResetPassword={onResetPassword}
      isTransitioning={isTransitioning}
    />
    <Logo logoUrl={logoUrl} />
    <TabNavigation
      currentTab={currentTab}
      onTabChange={onTabChange}
      userRole={userRole}
      isTransitioning={isTransitioning}
    />
  </header>
);

export default Header;
